export default {
	langId: 0,

	init() {
		let lang = parseInt(localStorage.getItem("lang"));
		if (!(lang <= langNamesList.length)) {
			this.langId = 0;
			localStorage.setItem("lang", "0");
		} else {
			this.langId = lang;
		}
	},

	getNames() {
		return langNamesList;
	},

	setLanguage(id) {
		this.langId = id;
		localStorage.setItem("lang", String(id));
	},

	getLanguage(id) {
		if (typeof id === "number") {
			return langList[id];
		} else {
			return langList[this.langId];
		}
	}
};

let langNamesList = ["中文", "English"];

let chinese = {
	"appName": "",
	"navHome": "主页",
	"navCatalog": "产品信息",
	"navSupport": "服务与支持",
	"navBlog": "公司动态",
	"navAbout": "关于我们",
	"navShop": "商城",
	"navMore": "更多...",
	"footer": "",
	"mainBlock": "玻璃油墨",
	"otherBlock": "其他油墨",
	"homeTitle": "墨高油墨",
	"homeSubtitle": "综合性玻璃油墨供应商",
	"homeFeedTitle": "最新动态",
	"catalogTitle": "产品信息",
	"catalogSubtitle": "浏览我们的各类产品",
	"catalogPrompt": "请选择产品类别。",
	"catalogBack": "显示所有类别",
	"catalogSearch": "搜索",
	"supportTitle": "服务与支持",
	"supportSubtitle": "联系方式与支持选项",
	"supportPhone": "致电\n+86 0757 88837571",
	"supportFax": "传真\n+86 0757 88837599",
	"supportChat": "QQ\n804182774",
	"supportEmail": "电子邮件\ninfo@moco-ink.com",
	"supportMap": "地址\n广东省佛山市高明区明城镇高明大道西486号",
	"supportDownload": "下载\n技术文档",
	"blogTitle": "公司动态",
	"blogSubtitle": "了解我们的最新情况",
	"blogLoadMore": "加载更多",
	"blogNoMore": "没有更早的动态",
	"aboutTitle": "关于我们",
	"aboutSubtitle": "了解公司信息",
	"detailsTitle": "产品详情",
	"newsTitle": "公司新闻",
	"newsSubtitle": "",
	"downloadsTitle": "下载",
	"downloadsSubtitle": "下载技术文档",
	"postReadMore": "点击查看详细信息。",
	"loading": "加载中..."
};

let english = {
	"appName": "",
	"navHome": "Home",
	"navCatalog": "Catalog",
	"navSupport": "Support",
	"navBlog": "Blog",
	"navAbout": "About Us",
	"navShop": "Shop",
	"navMore": "More...",
	"footer": "",
	"mainBlock": "Glass Based Ink",
	"otherBlock": "Other Ink",
	"homeTitle": "MOCO Ink",
	"homeSubtitle": "Comprehensive Glass Ink Supplier",
	"homeFeedTitle": "Recent Posts",
	"catalogTitle": "Product Catalog",
	"catalogSubtitle": "Explore our range of products.",
	"catalogPrompt": "Please select a category.",
	"catalogBack": "Show all categories",
	"catalogSearch": "Search",
	"supportTitle": "Support",
	"supportSubtitle": "View contact and support options.",
	"supportPhone": "Call us\n+86 0757 88837571",
	"supportFax": "Fax\n+86 0757 88837599",
	"supportChat": "QQ\n804182774",
	"supportEmail": "Email us\ninfo@moco-ink.com",
	"supportMap": "Find us\n486 West Gaoming Main Rd, Foshan, Guangdong",
	"supportDownload": "Download\nTechnical documents",
	"blogTitle": "Blog",
	"blogSubtitle": "Read our latest stories.",
	"blogLoadMore": "Load more",
	"blogNoMore": "You are at the end of the feed",
	"aboutTitle": "About Us",
	"aboutSubtitle": "Learn more about our company.",
	"detailsTitle": "Product Details",
	"newsTitle": "Company News",
	"newsSubtitle": "",
	"downloadsTitle": "Downloads",
	"downloadsSubtitle": "Download technical documents.",
	"postReadMore": "Click to read more.",
	"loading": "Loading..."
};

let langList = [chinese, english];
